import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './config/firebase'; // Import Firebase config first
import App from './App';
import { CRM_TYPE } from './utils/crmType';

const isReclassement = CRM_TYPE === 'reclassement';
const productName = isReclassement ? 'Reclassement' : 'Emploi';
const faviconPath = isReclassement ? '/favicon-reclassement.svg' : '/favicon.png';
document.title = `Anthea RH - CRM ${productName}`;

const iconLink = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
if (iconLink) {
  iconLink.href = `${faviconPath}?v=${CRM_TYPE}`;
  iconLink.type = isReclassement ? 'image/svg+xml' : 'image/png';
}
const appleLink = document.querySelector<HTMLLinkElement>('link[rel="apple-touch-icon"]');
if (appleLink) {
  appleLink.href = `${faviconPath}?v=${CRM_TYPE}`;
}
import './index.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Failed to find the root element');
}

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);